import type { SVGProps } from 'react';

import { unitMapping } from 'lib/style';

interface SVGRProps {
  size?: keyof typeof unitMapping;
  title?: string;
  titleId?: string;
}

export const Swap = ({
  size = 2,
  title,
  titleId,
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: unitMapping[size], height: unitMapping[size] }}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M4.31784 4.31397L3.25718 4.31396L0.0751953 7.49595L3.25718 10.6779H4.31783V8.24595L5.99982 8.24595V6.74595H4.31784L4.31784 4.31397Z"
      fill="#00F040"
    />
    <path
      d="M7.75717 7.67646L8.81783 7.67646L11.9998 4.49448L8.81784 1.3125L7.75718 1.3125L7.75718 3.74448L6.0752 3.74448L6.0752 5.24448H7.75718L7.75717 7.67646Z"
      fill="#FF0033"
    />
  </svg>
);
